import axios from "axios";
import nprogress from "nprogress"; //引入进度条模块
import "nprogress/nprogress.css"; //引入进度条样式
// var url = "http://127.0.0.1:8080"
var url = "//yuan.gzxb315.com";

const requests = axios.create({
  // 基础路径，发起请求的时候，路径当中会出现api
  baseURL: url + "/fwsyapi",
  //代表请求超时的时间5s
  timeout: 55000,
  // withCredentials: false,
});

// 请求拦截器：在发请求之前，请求拦截器可以检测到，可以在请求发出去之前做一些事情
requests.interceptors.request.use((config) => {
  // config：配置对象，对象里面有一个属性很重要，headers请求头

  // const token = localStorage.getItem('token');
  const token = sessionStorage.getItem("JigGyrBuasd");
  if (token) {
    config.headers["key"] = token;
  }

  // 启动进度条
  nprogress.start();
  return config;
});

// 响应拦截器
requests.interceptors.response.use(
  (res) => {
    // 成功回调函数：服务器响应数据回来以后，响应拦截器可以检测到

    // 关闭进度条
    nprogress.done();
    if (res.data.code == 203) {
      Notice.error({
        title: "验证失败",
        desc: "登录超时或已在别处登录",
      });
      window.location.href = "#/login";
      sessionStorage.removeItem("JigGyrBuasd");
      // alert('登录时间过久或在别处登录,请重新登录！');
    }
    return res.data;
  },
  (error) => {
    //响应失败的回调函数
    return Promise.reject(new Error("faile"));
  }
);

// 对外暴露
export default requests;
